import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import { useSelector } from "react-redux";
import Spinner from "../Spinner/Spinner";
import { Config } from "../../Config";
import "./CartModal.scss";

const CartModal = (props) => {
  const user = useSelector((state) => state.user);
  const cart = useSelector((state) => state.cart);
  const [address, setAddress] = useState("");

  const [showSpinner, setShowSpinner] = useState(false);
  useEffect(() => {
    if (user[0] !== undefined && user[0]?.address) {
      setAddress(user[0]?.address);
    }
    let body = document.body;
    body.style.overflowY = "hidden";
    return () => {
      body.style.overflowY = "auto";
    };
  }, []);

  const getTotalPrice = () => {
    let totalPrice = cart.map((item) => item.unitPrice * item.count);
    return totalPrice.reduce((acc, curr) => acc + curr, 0);
  };

  const paymentHandler = () => {
    setShowSpinner(true);
    if (cart.length > 0) {
      // return;
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", "Bearer " + user[0]?.token);

      let raw = JSON.stringify({
        AddressId: null,
        Price: getTotalPrice(),
      });

      let requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(Config.apiPath + "/Payment/Pay", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === 200) {
            setShowSpinner(false);
            window.location.replace(result.data.link);
            // props.history.push(`${result.data.link}`);
          }
        })
        .catch((error) => {
          setShowSpinner(false);
        });
    }
  };

  return (
    <div className="cartModalBox">
      <div className="cartModal">
        <div className="modalHeader">
          <span className="title">{props.title}</span>
          <FaTimes className="closeModalIcon" onClick={props.closeCartModal} />
        </div>
        <div className="modalContent">
          <div className="addressBox invalidCartInput">
            <p className="addressTitle">
              آدرس انتخاب شده:&nbsp;
              <span className="changeAddress" onClick={props.changeAddressHandler}>
                {address !== "" ? "(تغییر آدرس)" : "(ثبت آدرس)"}
              </span>
            </p>
            {address !== "" ? <p className="address">{address}</p> : <p className="address">آدرسی ثبت نشده است!</p>}
          </div>
          <p className="desc">برای تکمیل خرید یا مشاهده سبد خرید دکمه مربوطه را انتخاب کنید.</p>
          <div className="btnBoxes">
            <button className="showCart" onClick={props.showCartHandler}>
              مشاهده سبد خرید
            </button>
            <button className="goBank active" onClick={paymentHandler}>
              {showSpinner ? <Spinner color="#fff" /> : "پرداخت آنلاین"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(withRouter(CartModal));
